import { useEffect, useState } from "react";

export const useScrollShrink = (threshold = 10, topOffset = 40) => {
  const [compact, setCompact] = useState(false);

  useEffect(() => {
    //if (document.documentElement.classList.contains("android-app")) return;
    let lastY = window.scrollY;
    let ticking = false;

    const onScroll = () => {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(() => {
        const y    = window.scrollY;
        const diff = y - lastY;

        if (y < topOffset)            setCompact(false); // near top: always full size
        else if (diff >  threshold)   setCompact(true);  // swiping up: shrink
        else if (diff < -threshold)   setCompact(false); // scrolling back: expand

        if (Math.abs(diff) > threshold) lastY = y;
        ticking = false;
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold, topOffset]);

  return compact;
};